/** @format */

import clsx from 'clsx'
import React, {ComponentPropsWithoutRef} from 'react'

type ButtonVariant = 'primary' | 'secondary' | 'text'

type ButtonProps = {
  /**
   * Whether the button should be a primary button
   *
   * @deprecated Use variant="primary" instead
   */
  primary?: boolean
  /**
   * The variant of the button
   *
   * @default 'secondary'
   */
  variant?: ButtonVariant
  /**
   * Additional class name to add to the button
   */
  className?: string
} & ComponentPropsWithoutRef<'button'>

export default function Button({
  primary,
  variant = 'secondary',
  className,
  ...props
}: ButtonProps) {
  const buttonClassesByVariant: Record<ButtonVariant, string> = {
    primary: 'buttonPrimary',
    secondary: 'buttonSecondary',
    text: 'buttonText',
  }

  /**
   * Adds the appropriate button class based on the variant prop
   * Ensures backwards compatibility with the old button usage where primary was used instead of variant="primary"
   */
  const buttonClass = primary
    ? buttonClassesByVariant.primary
    : buttonClassesByVariant[variant || 'secondary']

  return <button className={clsx(buttonClass, className)} {...props} />
}
